import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hca-loyalty-website-landing-page',
  templateUrl: './hca-loyalty-website-landing-page.component.html',
  styleUrls: ['./hca-loyalty-website-landing-page.component.scss']
})
export class HcaLoyaltyWebsiteLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/hca-loyalty-website-landing-page/hca-loyalty-website-landing-page.component.ts